import React from 'react';
import ReactDOM from 'react-dom/client';
import './design/tokens.css';
import './index.css';
import './design/ui.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();